import { useGetClientProfile } from '@/api/clients/get-client-profile'
import { GiftCardsDashboard } from '@/pages/gift-cards/gift-cards-dashboard'

import * as S from './gift-cards.styled'
import { ClientProfileGiftCardsProps } from './gift-cards.types'

export const GiftCards = ({ clientId }: ClientProfileGiftCardsProps) => {
  const { data: clientData, isLoading } = useGetClientProfile({ clientId })

  if (isLoading || !clientData) return null

  const resident = {
    apartment: clientData.apartment,
    buildingNumber: clientData.buildingNumber,
    email: clientData.user.email,
    id: Number(clientId),
    name: `${clientData.user.firstName} ${clientData.user.lastName}`,
    phone: clientData.phone,
  }

  return (
    <S.Container>
      <GiftCardsDashboard resident={resident} building={clientData.buildingId} />
    </S.Container>
  )
}
